// extracted by mini-css-extract-plugin
export default {"error":"OoRnh","travolta":"kl1j0"};